import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fw-framework-body',
  template: require('./framework-body.component.html'),
  styles: [require('./framework-body.component.css')]
})
export class FrameworkBodyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/framework-body/framework-body.component.ts